export default "__VITE_ASSET__D2UbD_4i__"